import { useCallback } from 'react';

const usePrev = ({
  advancedForm,
  setAlert,
  alert,
}) => {
  const onPrev = useCallback(() => {
    const currentAdvancedSettings = advancedForm.getFieldsValue();
    setAlert({...alert, ...currentAdvancedSettings});
  }, [advancedForm.current, alert]);

  return onPrev;
};

export default usePrev;
